
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'embedded-viral-link-ui',
  currentProjectVersion: 'static-1.6270',
  depVersions: {
  "embedded-viral-link-ui": "static-1.6270",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7886",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11317",
  "I18n": "static-7.1598",
  "jasmine-runner": "static-1.6344",
  "quartz": "static-1.6831",
  "quartz-core": "static-1.6050",
  "react-dlb": "static-1.74",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.764",
  "enviro": "static-4.416",
  "foundations-components": "static-1.7666",
  "history": "static-4.47",
  "hub-http": "static-1.6093",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11625",
  "icons": "static-2.637",
  "immer": "static-1.33",
  "laboratory-lib": "static-3.7035",
  "PortalIdParser": "static-2.377",
  "quartz-config": "static-1.609",
  "quartz-routing": "static-1.261",
  "quick-fetch": "static-1.3807",
  "react": "static-7.182",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16527",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5242",
  "react-virtualized": "static-2.96",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "signup-constants": "static-1.18586",
  "signup-ui-lego-core": "static-1.20596",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.485",
  "ui-addon-react-router-dom": "static-1.9419",
  "ui-images": "static-2.1124",
  "UIComponents": "static-3.8264",
  "usage-tracker": "static-1.7211",
  "usage-tracker-core": "static-1.7061",
  "viral-links-lib": "static-1.6916",
  "hs-promise-rejection-tracking": "static-1.5433",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "bend-plugin-trellis-migration": "static-1.3301",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3108",
  "quartz-webpack": "static-1.3055",
  "HeadJS": "static-2.732",
  "framer-motion": "static-1.69",
  "hs-test-utils-bend-plugin": "static-1.2997",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "foundations-theming": "static-1.4284",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "jasmine": "static-4.4199",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4547",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.20",
  "quartz-auth": "static-1.506",
  "quartz-head": "static-1.496",
  "quartz-i18n": "static-1.506",
  "quartz-test": "static-1.506",
  "quartz-tracking": "static-1.210",
  "ui-fonts": "static-1.579",
  "usage-tracker-container": "static-1.7201",
  "sassPrefix": "static-1.153",
  "bend-plugin-foundations-components": "static-1.3935",
  "floating-ui": "static-1.53",
  "foundations-assets": "static-1.4714",
  "foundations-theming-specialty": "static-1.2000",
  "hs-story-utils": "static-1.9301",
  "react-aria": "static-1.63",
  "tanstack-table": "static-1.52",
  "trellis-assets": "static-1.1432",
  "superstore": "static-1.4642",
  "csstype": "static-1.50",
  "rpc-client-utils": "static-1.4518",
  "emoji-regex": "static-1.7",
  "PatternValidationJS": "static-1.437",
  "signup-ui-url-generator": "static-2.7911",
  "bender-build-tools": "static-1.3041",
  "bend-plugin-foundations-theming": "static-1.2767",
  "foundations-theming-base": "static-1.3269",
  "stylex": "static-1.29",
  "hub-http-shared-msw-handlers": "static-1.9664",
  "hubspotter-http-shared-msw-handlers": "static-1.9662",
  "usage-tracker-session-replay": "static-1.4897",
  "chirp-fetch": "static-1.1756",
  "ts-schema": "static-1.3974",
  "amplitude-session-replay-browser": "static-1.57"
},
  depPathPrefixes: {
  "embedded-viral-link-ui": "/embedded-viral-link-ui/static-1.6270",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7886",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11317",
  "I18n": "/I18n/static-7.1598",
  "jasmine-runner": "/jasmine-runner/static-1.6344",
  "quartz": "/quartz/static-1.6831",
  "quartz-core": "/quartz-core/static-1.6050",
  "react-dlb": "/react-dlb/static-1.74",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.764",
  "enviro": "/enviro/static-4.416",
  "foundations-components": "/foundations-components/static-1.7666",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6093",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11625",
  "icons": "/icons/static-2.637",
  "immer": "/immer/static-1.33",
  "laboratory-lib": "/laboratory-lib/static-3.7035",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "quartz-config": "/quartz-config/static-1.609",
  "quartz-routing": "/quartz-routing/static-1.261",
  "quick-fetch": "/quick-fetch/static-1.3807",
  "react": "/react/static-7.182",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16527",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5242",
  "react-virtualized": "/react-virtualized/static-2.96",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "signup-constants": "/signup-constants/static-1.18586",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20596",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9419",
  "ui-images": "/ui-images/static-2.1124",
  "UIComponents": "/UIComponents/static-3.8264",
  "usage-tracker": "/usage-tracker/static-1.7211",
  "usage-tracker-core": "/usage-tracker-core/static-1.7061",
  "viral-links-lib": "/viral-links-lib/static-1.6916",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3301",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3108",
  "quartz-webpack": "/quartz-webpack/static-1.3055",
  "HeadJS": "/HeadJS/static-2.732",
  "framer-motion": "/framer-motion/static-1.69",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2997",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "foundations-theming": "/foundations-theming/static-1.4284",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "jasmine": "/jasmine/static-4.4199",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4547",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.20",
  "quartz-auth": "/quartz-auth/static-1.506",
  "quartz-head": "/quartz-head/static-1.496",
  "quartz-i18n": "/quartz-i18n/static-1.506",
  "quartz-test": "/quartz-test/static-1.506",
  "quartz-tracking": "/quartz-tracking/static-1.210",
  "ui-fonts": "/ui-fonts/static-1.579",
  "usage-tracker-container": "/usage-tracker-container/static-1.7201",
  "sassPrefix": "/sassPrefix/static-1.153",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3935",
  "floating-ui": "/floating-ui/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4714",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2000",
  "hs-story-utils": "/hs-story-utils/static-1.9301",
  "react-aria": "/react-aria/static-1.63",
  "tanstack-table": "/tanstack-table/static-1.52",
  "trellis-assets": "/trellis-assets/static-1.1432",
  "superstore": "/superstore/static-1.4642",
  "csstype": "/csstype/static-1.50",
  "rpc-client-utils": "/rpc-client-utils/static-1.4518",
  "emoji-regex": "/emoji-regex/static-1.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7911",
  "bender-build-tools": "/bender-build-tools/static-1.3041",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2767",
  "foundations-theming-base": "/foundations-theming-base/static-1.3269",
  "stylex": "/stylex/static-1.29",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9664",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9662",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4897",
  "chirp-fetch": "/chirp-fetch/static-1.1756",
  "ts-schema": "/ts-schema/static-1.3974",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57"
}
};
